import { apsisEncrypt } from './apsisEncryption';
import fetchWrapper from './fetchWrapper';
import Swal from 'sweetalert2';

export function swalConfirm($msg, $title, $cText) {
	try {
		const result = Swal.fire({
			title: $title || 'Are you sure',
			text: $msg || 'you want to proceed?',
			icon: 'warning',
			showCloseButton: true,
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: $cText || 'Yes, Confirm',
			allowOutsideClick: false,
		});
		return result;
	} catch (e) {
		// Fail!
		console.error(e);
		return false;
	}
}

// Error Message
export function swalError($msg, $title = 'Oops...') {
	try {
		const result = Swal.fire({
			icon: 'error',
			title: $title,
			text: $msg,
			showCloseButton: true,
			showConfirmButton: true,
			allowOutsideClick: true,
			timer: 60000,
		});
		return result;
	} catch (e) {
		// Fail!
		console.error(e);
		return false;
	}
}

// Success Message
export function swalSuccess($text = 'Your work has been saved!', $title = 'Success!', $html = false) {
	try {
		let result = '';
		if ($html != false) {
			result = Swal.fire({
				icon: 'success',
				title: $title,
				html: $html,
				showCloseButton: true,
				showConfirmButton: true,
				allowOutsideClick: true,
				timer: 60000,
			});
		} else {
			result = Swal.fire({
				icon: 'success',
				title: $title,
				text: $text,
				showCloseButton: true,
				showConfirmButton: true,
				allowOutsideClick: true,
				timer: 60000,
			});
		}
		return result;
	} catch (e) {
		// Fail!
		console.error(e);
		return false;
	}
}

export async function changeModule(moduleId, check = false) {
	const prevPath = localStorage.getItem('prevPath') ? JSON.parse(localStorage.getItem('prevPath')) : false;
	if (moduleId) {
		await fetchWrapper
			.get(`modulechanger/${moduleId}`)
			.then((response) => {
				if (!response.error) {
					const module = response.data;
					localStorage.setItem('module_info', JSON.stringify(module.module_info));
					localStorage.setItem('menu_list', JSON.stringify(module.menu_list));
					localStorage.setItem('default_password_check', JSON.stringify(module.default_password_check));
					// Message.success("Sign in complete. Taking you to your dashboard!");
					if (module.module_info.module_name === 'HRMS') {
						const userData = localStorage.getItem('user');
						window.location.href = module.module_info.module_url + `?user=${apsisEncrypt(userData)}`;
					} else {
						window.location.href = check && prevPath ? prevPath : module.module_info.module_url;
					}
				}
			})
			.catch((error) => {
				console.log(error);
			});
	} else {
		window.location.href = check && prevPath ? prevPath : '/';
	}
}

export async function getAuthorizedModules() {
	await fetchWrapper
		.get('modulechanger/authorized-list')
		.then((response) => {
			localStorage.setItem('module_list', JSON.stringify(response.data));
		})
		.catch((error) => {
			console.log(error);
		});
}

const toObject = (arr) => arr.reduce((a, b) => ({ ...a, [b.label]: b.value }), {});

export async function getUomPrecision() {
	await fetchWrapper
		.post('dropdown/dropdowndata', {
			dropdown_slug: 'uom_precision',
		})
		.then((response) => {
			if (!response.error) {
				const data = toObject(response.data);
				localStorage.setItem('uom_precision', JSON.stringify(data));
			}
		})
		.catch((error) => {
			console.log(error);
		});
}

// get form element
export async function getFormData(slug) {
	const response = await fetchWrapper.post('masterform/getformdata', {
		form_slug: slug,
	});
	if (response.data) {
		return response.data;
	} else {
		return null;
	}
}

export const afterSigninTasks = async (user) => {
	localStorage.setItem('user', JSON.stringify(user));
	await getAuthorizedModules();
	await getUomPrecision();
	await changeModule(user.default_module_id, true);
};
